var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"upload",staticClass:"upload-img",attrs:{"drag":true,"accept":"image/*","action":"","multiple":false,"show-file-list":false,"on-success":_vm.handleAvatarSuccess,"before-upload":_vm.beforeAvatarUpload}},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }